import { useCallback, useSyncExternalStore } from 'react';
import { useAuth } from '@/features/auth/AuthContext';
import { getAdminViewAsUserId } from '@/features/auth/services/adminViewAs';
import { noteAutosaveCoordinator, noteDraftAccountPrefix, type NoteSaveStatus } from '../services/noteAutosave';

export const useNoteSaveStatus = (): NoteSaveStatus => {
  const { user, actualUser } = useAuth();
  const prefix = user ? noteDraftAccountPrefix(actualUser?.id || user.id, user.id, getAdminViewAsUserId()) : null;
  const snapshot = useCallback(() => prefix ? noteAutosaveCoordinator.accountStatus(prefix) : 'idle', [prefix]);
  return useSyncExternalStore(noteAutosaveCoordinator.subscribeAccount, snapshot, snapshot);
};
